import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import {
  Button,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Spin,
  Table,
  notification,
} from "antd";
import { AppContext } from "../App.context";
import axios from "axios";

import {
  checkEmpty,
  getAboutLot,
  getAboutLotSummaryOrder,
  getCheckHeveGetNew,
  getCurrentDateUtilYYYY,
  getDateUtilYYYY,
  getDateUtilYYYYBydate,
  getLotResults,
  getLotsByType,
  getOrders,
  getOrdersV2,
  getPreventLot,
  getRmNumday,
  getToken,
  isAdmin,
  newDateUtil,
  numberWithCommas,
  parseJwt,
  reflectorLots_2,
  reverseString3,
  savePreventApi,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import LotTable from "../lotTable/LotTable";
import { SearchOutlined } from "@ant-design/icons";
import LoadingCenter from "./LoadingCenter";
import LoadingCenterContent from "./LoadingCenterContent";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

function LotSummaryNumber(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

function Content(props) {
  const appContext = useContext(AppContext);
  const [lots, setLots] = useState([]);
  const [lotSelected, setLotSelected] = useState([]);
  const [typeSelectd, setTypeSelect] = useState("type1");
  const [orders, setOrders] = useState([]);
  const [lotResualts, setLotResualts] = useState([]);
  const [lotResualt, setLotResualt] = useState(null);
  const [datas, setDatas] = useState([]);
  const [lotTypes, setLotTypes] = useState([]);
  const [selectMonth, setSelectMonth] = useState("");
  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");
  const [searchType, setSearchType] = useState("today");
  const [loading, setLoading] = useState(false);

  const [lot_2_tops, setLot_2_tops] = useState([]);
  const [lot_3_tops, setLot_3_tops] = useState([]);
  const [lot_2_bottoms, setLot_2_bottoms] = useState([]);
  const [lot_3_bottoms, setLot_3_bottoms] = useState([]);
  const [lot_3_tots, setLot_3_tots] = useState([]);
  const [lot_run_tops, setLot_run_tops] = useState([]);
  const [lot_run_bottoms, setLot_run_bottoms] = useState([]);

  const [lot_2_top_buy, setLot_2_top_buy] = useState(0);
  const [lot_3_top_buy, setLot_3_top_buy] = useState(0);
  const [lot_2_bottom_buy, setLot_2_bottom_buy] = useState(0);
  const [lot_3_bottom_buy, setLot_3_bottom_buy] = useState(0);
  const [lot_3_tot_buy, setLot_3_tot_buy] = useState(0);
  const [lot_run_top_buy, setLot_run_top_buy] = useState(0);
  const [lot_run_bottom_buy, setLot_run_bottom_buy] = useState(0);

  const [lot_2_top_recive, setLot_2_top_recive] = useState(0);
  const [lot_3_top_recive, setLot_3_top_recive] = useState(0);
  const [lot_2_bottom_recive, setLot_2_bottom_recive] = useState(0);
  const [lot_3_bottom_recive, setLot_3_bottom_recive] = useState(0);
  const [lot_3_tot_recive, setLot_3_tot_recive] = useState(0);
  const [lot_run_top_recive, setLot_run_top_recive] = useState(0);
  const [lot_run_bottom_recive, setLot_run_bottom_recive] = useState(0);

  const [lot_2_top_pay, setLot_2_top_pay] = useState(0);
  const [lot_3_top_pay, setLot_3_top_pay] = useState(0);
  const [lot_2_bottom_pay, setLot_2_bottom_pay] = useState(0);
  const [lot_3_bottom_pay, setLot_3_bottom_pay] = useState(0);
  const [lot_3_tot_pay, setLot_3_tot_pay] = useState(0);
  const [lot_run_top_pay, setLot_run_top_pay] = useState(0);
  const [lot_run_bottom_pay, setLot_run_bottom_pay] = useState(0);

  const [total_pay, setTotal_pay] = useState(0);
  const [total_recive, setTotal_recive] = useState(0);
  const [total_buy, setTotal_buy] = useState(0);

  const [numberTotalMain, setNumberTotalMain] = useState(0);

  const [isAdminMain, setIsAdminMain] = useState(false);

  const [prevent_3_top, setprevent_3_top] = useState("");
  const [dateFrom, setdateFrom] = useState("");
  const [dateTo, setdateTo] = useState("");
  const [prevent_3_bottom, setprevent_3_bottom] = useState("");
  const [prevent_3_tot, setprevent_3_tot] = useState("");
  const [prevent_2_top, setprevent_2_top] = useState("");
  const [prevent_2_bottom, setprevent_2_bottom] = useState("");
  const [prevent_run_top, setprevent_run_top] = useState("");
  const [prevent_run_bottom, setprevent_run_bottom] = useState("");
  const [activeCollapKey, setActiveCollapKey] = useState("1");
  const refSearchBtn = useRef(null);

  const refTop = useRef(null);

  const [userInfo, setUserInfo] = useState({});
  useEffect(() => {
    let user = parseJwt(getToken());
    setUserInfo(user);
  }, []);

  const loaderData = async () => {
    // let havegetnew = await getCheckHeveGetNew();
    let havegetnew = false;
    let aboutLot = null;
    if (!checkEmpty(localStorage.getItem("aboutLot")) && havegetnew == false) {
      aboutLot = JSON.parse(localStorage.getItem("aboutLot"));
    } else {
      try {
        aboutLot = await getAboutLot();
        localStorage.setItem("aboutLot", JSON.stringify(aboutLot));
        console.log("aboutLot", aboutLot);
      } catch (e) {}
    }

    setLotTypes(aboutLot.lotTypes);
    setLots(Object.assign([], reflectorLots_2(aboutLot.lots)));
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getCurrentDateUtilYYYY();
    setdateFrom(dateFrom);
    setdateTo(dateTo);

    setLoading(true);
    try {
      console.log("appContext.acUsername", appContext.acUsername);
      // let lotResualtsRes = await getLotResults(datefrom, dateto);
      // setLotResualts(lotResualtsRes);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    loaderData();
    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        setIsAdminMain(true);
      } else {
        setIsAdminMain(false);
      }
    }
  }, []);

  const searchAction = async () => {
    let datefrom = getCurrentDateUtilYYYY();
    let dateto = getCurrentDateUtilYYYY();
    if (searchType == "today") {
      datefrom = getCurrentDateUtilYYYY();
      dateto = getCurrentDateUtilYYYY();
    } else if (searchType == "yesterday") {
      var date = newDateUtil();
      date.setDate(date.getDate() - 1);
      let dateStr = getDateUtilYYYYBydate(date);
      datefrom = dateStr;
      dateto = dateStr;
    } else if (searchType == "this_week") {
      var curr = newDateUtil(); // get current date
      let day = curr.getDay();
      let rmnumday = getRmNumday(day);
      let firstD = newDateUtil();
      firstD.setDate(firstD.getDate() - rmnumday);
      let lastD = newDateUtil();
      lastD.setDate(lastD.getDate() - rmnumday + 6);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "old_week") {
      var curr = newDateUtil(); // get current date
      let day = curr.getDay();
      let rmnumday = getRmNumday(day);
      let firstD = newDateUtil();
      firstD.setDate(firstD.getDate() - rmnumday - 7);
      let lastD = newDateUtil();
      lastD.setDate(lastD.getDate() - rmnumday - 7 + 6);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "month") {
      var month = selectMonth - 1;
      var firstD = new Date(newDateUtil().getFullYear(), month, 1);
      var lastD = new Date(newDateUtil().getFullYear(), month + 1, 0);
      let dateStrF = getDateUtilYYYYBydate(firstD);
      let dateStrT = getDateUtilYYYYBydate(lastD);
      datefrom = dateStrF;
      dateto = dateStrT;
    } else if (searchType == "date_from_to") {
      datefrom = selectDateFrom;
      if (checkEmpty(selectDateTo)) {
        setSelectDateTo(selectDateFrom);
        dateto = selectDateFrom;
      } else {
        dateto = datefrom;
        dateto = selectDateTo;
      }
    }
    setdateFrom(datefrom);
    setdateTo(dateto);

    setLotResualt(null);
    try {
      setLoading(true);
      let lotids = `'${lotSelected}'`;
      let istype = "Y";
      let data = await getOrdersV2(
        datefrom,
        dateto,
        appContext.acUsername,
        null,
        lotids,
        istype
      );
      // let lotResualtsRes = await getLotResults(datefrom, dateto);
      setLotResualts(Object.assign([], data.lotResualts));
      let lotResualt = null;
      if (datefrom == dateto || searchType == "today") {
        for (let a = 0; a < data.lotResualts.length; a++) {
          let dstr = getDateUtilYYYY(data.lotResualts[a].lot_date);
          // console.log("dstr", dstr);
          if (data.lotResualts[a].lot_id == lotSelected && datefrom == dstr) {
            // console.log("data.lotResualts[a]", data.lotResualts[a]);
            lotResualt = data.lotResualts[a];
            setLotResualt(data.lotResualts[a]);
            break;
          }
        }
      }
      // setOrders(Object.assign([], data.orders));

      setLotTypes(Object.assign([], lotTypes));
      setLots(Object.assign([], reflectorLots_2(lots)));
      setLoading(false);
      reflectorOrder(
        Object.assign([], data.orders),
        data.lotResualts,
        lots,
        lotSelected
      );
      setOrders(Object.assign([], data.orders));
    } catch (e) {}

    setprevent_3_top("");
    setprevent_3_bottom("");
    setprevent_3_tot("");
    setprevent_2_top("");
    setprevent_2_bottom("");
    setprevent_run_top("");
    setprevent_run_bottom("");

    try {
      let preventLot = await getPreventLot(lotSelected, appContext.acUsername);

      setprevent_3_top(
        !checkEmpty(preventLot.lot_3_top) ? preventLot.lot_3_top : ""
      );
      setprevent_3_bottom(
        !checkEmpty(preventLot.lot_3_bottom) ? preventLot.lot_3_bottom : ""
      );
      setprevent_3_tot(
        !checkEmpty(preventLot.lot_3_tot) ? preventLot.lot_3_tot : ""
      );
      setprevent_2_top(
        !checkEmpty(preventLot.lot_2_top) ? preventLot.lot_2_top : ""
      );
      setprevent_2_bottom(
        !checkEmpty(preventLot.lot_2_bottom) ? preventLot.lot_2_bottom : ""
      );
      setprevent_run_top(
        !checkEmpty(preventLot.lot_run_top) ? preventLot.lot_run_top : ""
      );
      setprevent_run_bottom(
        !checkEmpty(preventLot.lot_run_bottom) ? preventLot.lot_run_bottom : ""
      );
    } catch (e) {}
  };

  const reflectorOrder = (ordersRes, lotResualts, lots) => {
    let datas = [];
    let send_out_main = 0;
    let done_price_main = 0;
    let totalMain = 0;

    let lot_3_top = getLotsByType(
      "lot_top_price",
      "lot_3",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    let lot_3_bottom = getLotsByType(
      "lot_bottom_price",
      "lot_3",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    let lot_2_top = getLotsByType(
      "lot_top_price",
      "lot_2",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    let lot_2_bottom = getLotsByType(
      "lot_bottom_price",
      "lot_2",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );

    let lot_run_top = getLotsByType(
      "lot_run_top_price",
      "",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    let lot_run_bottom = getLotsByType(
      "lot_run_bottom_price",
      "",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    let lot_3_tot = getLotsByType(
      "lot_tot_price",
      "",
      ordersRes,
      lotSelected,
      lotResualts,
      userInfo
    );
    // console.log("allLot3_top", lot_3_top);
    // console.log("allLot3_bottom", lot_3_bottom);
    // console.log("allLot2_top", lot_2_top);
    // console.log("allLot2_bottom", lot_2_bottom);
    // console.log("allLot3_tot", lot_3_tot);
    // console.log("allLot_run_top", lot_run_top);
    // console.log("allLot_run_bottom", lot_run_bottom);

    setLot_2_bottom_buy(numberWithCommas(lot_2_bottom.buy));
    setLot_2_bottom_pay(numberWithCommas(lot_2_bottom.pay * -1));
    setLot_2_bottom_recive(numberWithCommas(lot_2_bottom.recive));
    setLot_2_bottoms(lot_2_bottom.allNumbers);

    setLot_3_bottom_buy(numberWithCommas(lot_3_bottom.buy));
    setLot_3_bottom_pay(numberWithCommas(lot_3_bottom.pay * -1));
    setLot_3_bottom_recive(numberWithCommas(lot_3_bottom.recive));
    setLot_3_bottoms(lot_3_bottom.allNumbers);

    setLot_2_top_buy(numberWithCommas(lot_2_top.buy));
    setLot_2_top_pay(numberWithCommas(lot_2_top.pay * -1));
    setLot_2_top_recive(numberWithCommas(lot_2_top.recive));
    setLot_2_tops(lot_2_top.allNumbers);

    setLot_3_top_buy(numberWithCommas(lot_3_top.buy));
    setLot_3_top_pay(numberWithCommas(lot_3_top.pay * -1));
    setLot_3_top_recive(numberWithCommas(lot_3_top.recive));
    setLot_3_tops(lot_3_top.allNumbers);

    setLot_3_tot_buy(numberWithCommas(lot_3_tot.buy));
    setLot_3_tot_pay(numberWithCommas(lot_3_tot.pay * -1));
    setLot_3_tot_recive(numberWithCommas(lot_3_tot.recive));
    setLot_3_tots(lot_3_tot.allNumbers);

    setLot_run_bottom_buy(numberWithCommas(lot_run_bottom.buy));
    setLot_run_bottom_pay(numberWithCommas(lot_run_bottom.pay * -1));
    setLot_run_bottom_recive(numberWithCommas(lot_run_bottom.recive));
    setLot_run_bottoms(lot_run_bottom.allNumbers);

    setLot_run_top_buy(numberWithCommas(lot_run_top.buy));
    setLot_run_top_pay(numberWithCommas(lot_run_top.pay * -1));
    setLot_run_top_recive(numberWithCommas(lot_run_top.recive));
    setLot_run_tops(lot_run_top.allNumbers);

    setTotal_recive(
      numberWithCommas(
        lot_2_bottom.recive +
          lot_2_top.recive +
          lot_3_bottom.recive +
          lot_3_top.recive +
          lot_3_tot.recive +
          lot_run_bottom.recive +
          lot_run_top.recive
      )
    );
    setTotal_buy(
      numberWithCommas(
        lot_2_bottom.buy +
          lot_2_top.buy +
          lot_3_bottom.buy +
          lot_3_top.buy +
          lot_3_tot.buy +
          lot_run_bottom.buy +
          lot_run_top.buy
      )
    );
    setTotal_pay(
      numberWithCommas(
        (lot_2_bottom.pay +
          lot_2_top.pay +
          lot_3_bottom.pay +
          lot_3_top.pay +
          lot_3_tot.pay +
          lot_run_bottom.pay +
          lot_run_top.pay) *
          -1
      )
    );
    let numberTotal = lot_3_top.allNumbers.length;
    if (lot_3_bottom.allNumbers.length > numberTotal)
      numberTotal = lot_3_bottom.allNumbers.length;
    if (lot_2_top.allNumbers.length > numberTotal)
      numberTotal = lot_2_top.allNumbers.length;
    if (lot_2_bottom.allNumbers.length > numberTotal)
      numberTotal = lot_2_bottom.allNumbers.length;
    if (lot_3_tot.allNumbers.length > numberTotal)
      numberTotal = lot_3_tot.allNumbers.length;
    if (lot_run_bottom.allNumbers.length > numberTotal)
      numberTotal = lot_run_bottom.allNumbers.length;
    if (lot_run_top.allNumbers.length > numberTotal)
      numberTotal = lot_run_top.allNumbers.length;
    setNumberTotalMain(numberTotal);
  };

  let months = [
    {
      value: "1",
      label: "มกราคม",
    },
    {
      value: "2",
      label: "กุมภาพันธ์",
    },
    {
      value: "3",
      label: "มีนาคม ",
    },
    {
      value: "4",
      label: "เมษายน",
    },
    {
      value: "5",
      label: "พฤษภาคม",
    },
    {
      value: "6",
      label: "มิถุนายน",
    },
    {
      value: "7",
      label: "กรกฎาคม",
    },
    {
      value: "8",
      label: "สิงหาคม",
    },
    {
      value: "9",
      label: "กันยายน",
    },
    {
      value: "10",
      label: "ตุลาคม",
    },
    {
      value: "11",
      label: "พฤศจิกายน",
    },
    {
      value: "12",
      label: "ธันวาคม",
    },
  ];

  const columns = [
    {
      title: "หวย",
      dataIndex: "lot_name",
      key: "lot_name",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { lot_name }) => (
        <>
          <span style={{ color: "blue", fontWeight: lot_name.fontWeight }}>
            {lot_name.text}
          </span>
        </>
      ),
    },
    {
      title: "ส่งออก",
      dataIndex: "send_out",
      key: "send_out",
      // render: (text) => <span style={{ color: "blue" }}>{text}</span>,
      render: (_, { send_out }) => (
        <>
          <span style={{ color: "red", fontWeight: send_out.fontWeight }}>
            {send_out.text}
          </span>
        </>
      ),
    },
    {
      title: "ถูกรางวัล",
      key: "done_price",
      dataIndex: "done_price",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { done_price }) => (
        <>
          <span style={{ color: "green", fontWeight: done_price.fontWeight }}>
            {done_price.text}
          </span>
        </>
      ),
    },
    {
      title: "รวม",
      key: "total",
      dataIndex: "total",
      // render: (text) => <span style={{ color: "green" }}>{text}</span>,
      render: (_, { total }) => (
        <>
          <span style={{ color: total.color, fontWeight: total.fontWeight }}>
            {total.text}
          </span>
        </>
      ),
    },
  ];

  // const selectAllFn = (lots) => {
  //   let ids = [];
  //   for (let a = 0; a < lots.length; a++) {
  //     ids.push(lots[a].lot_id);
  //   }
  //   setLotSelecteds(Object.assign([], ids));
  //   return ids;
  // };

  const [api, contextHolderDone] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };
  const savePrevent = async () => {
    try {
      let body = {
        lot_id: lotSelected,
        username: appContext.acUsername,
        prevent_2_bottom,
        prevent_2_top,
        prevent_3_bottom,
        prevent_3_top,
        prevent_3_tot,
        prevent_run_bottom,
        prevent_run_top,
      };
      await savePreventApi(body);
      openNotificationWithIcon("success", "ตั้งรับ", "ตั้งรับสำเร็จ");
    } catch (e) {
      openNotificationWithIcon("error", "ตั้งรับ", "ตั้งรับไม่สำเร็จ");
    }
  };

  const itemCollabs = [
    {
      key: "1",
      label: "เลือกรายการ",
      children: (
        <div style={{ width: "100%" }}>
          {lotTypes.map((type) => {
            return (
              <>
                <div className={styles.hearderSearchType}>{type.lot_type}</div>
                <div className={styles.boxSearchSelected}>
                  {lots
                    .filter((lot) => lot.lot_type == type.lot_type)
                    .map((lot) => {
                      return (
                        <div
                          className={
                            lotSelected == lot.lot_id
                              ? styles.itemSearchSelectActive
                              : styles.itemSearchSelect
                          }
                          onClick={() => {
                            setLotSelected(lot.lot_id);
                          }}
                        >
                          {lot.lot_name}
                        </div>
                      );
                    })}
                </div>
              </>
            );
          })}
          <div style={{ textAlignLast: "end" }}>
            <Button
              className={styles.btnCloseCollapse}
              // type="primary"
              // icon={<SearchOutlined />}
              onClick={() => {
                setActiveCollapKey("");

                refSearchBtn.current.click();
              }}
            >
              ปิด
            </Button>
          </div>
        </div>
      ),
      // showArrow: false,
    },
  ];

  return (
    <>
      <div className={styles.box100}>
        {isAdminMain && (
          <div style={{ padding: "10px" }} className={styles.headerSetResualt}>
            กำลังดูของ : {appContext.acUsername}
          </div>
        )}

        <div className={styles.boxSearch}>
          <div className={styles.detailCard}>
            <div>
              <div style={{ display: "flex" }}>
                <div
                  className={
                    searchType == "today"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("today");
                  }}
                >
                  วันนี้
                </div>
                <div
                  className={
                    searchType == "yesterday"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("yesterday");
                  }}
                >
                  เมื่อวาน
                </div>
                <div
                  className={
                    searchType == "this_week"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("this_week");
                  }}
                >
                  สัปดาห์นี้
                </div>
                <div
                  className={
                    searchType == "old_week"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("old_week");
                  }}
                >
                  สัปดาห์ที่แล้ว
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  className={
                    searchType == "month"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("month");
                  }}
                >
                  เดือน
                </div>
                <div className={styles.selectMont}>
                  <Select
                    // showSearch
                    className={styles.selectMountSearch}
                    style={{ width: 200 }}
                    placeholder="เลือกเดือน"
                    optionFilterProp="children"
                    onChange={(v) => {
                      setSelectMonth(v);
                      setSearchType("month");
                    }}
                    options={months}
                  />
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  className={
                    searchType == "date_from_to"
                      ? styles.searchTypeAc
                      : styles.searchType
                  }
                  onClick={() => {
                    setSearchType("date_from_to");
                  }}
                >
                  ตั้งแต่วันที่
                </div>
                <div className={styles.selectDateFomTo}>
                  {/* <RangePicker
                    onChange={(dates, dateStrings) => {
                      console.log("dateStrings", dateStrings);
                      if (!checkEmpty(dateStrings[0])) {
                        // let dateF = getDateUtilYYYYBydate(dateStrings[0]);
                        // console.log(dateF);
                        setSelectDateFrom(dateStrings[0]);
                      }
                      if (!checkEmpty(dateStrings[1])) {
                        // let dateT = getDateUtilYYYYBydate(dateStrings[1]);
                        setSelectDateTo(dateStrings[1]);
                      }
                    }}
                  /> */}

                  <DatePicker
                    className={styles.datefromtoSearch}
                    placeholder="ตั้งเเต่วันที่"
                    value={
                      checkEmpty(selectDateFrom)
                        ? ""
                        : dayjs(selectDateFrom, "YYYY-MM-DD")
                    }
                    onChange={(dates, dateString) => {
                      console.log("dateString", dateString);
                      setSelectDateFrom(dateString);
                      setSearchType("date_from_to");
                      if (checkEmpty(selectDateTo)) setSelectDateTo(dateString);
                    }}
                  />
                  <span className={styles.datefromto}>ถึง</span>
                  <DatePicker
                    value={
                      checkEmpty(selectDateTo)
                        ? ""
                        : dayjs(selectDateTo, "YYYY-MM-DD")
                    }
                    className={styles.datefromtoSearch}
                    placeholder="ถึงวันที่"
                    onChange={(dates, dateString) => {
                      console.log("dateString", dateString);
                      setSelectDateTo(dateString);
                      setSearchType("date_from_to");
                    }}
                  />
                </div>
              </div>
              <div>
                <Button
                  className={styles.btnSearchSum}
                  ref={refSearchBtn}
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={() => {
                    searchAction();
                    setActiveCollapKey("");
                  }}
                >
                  ค้นหา
                </Button>
              </div>
            </div>

            <div className={styles.boxSelectCollaps}>
              <Collapse
                items={itemCollabs}
                activeKey={activeCollapKey}
                defaultActiveKey={activeCollapKey}
                onChange={(e) => {
                  if (checkEmpty(activeCollapKey)) setActiveCollapKey("1");
                  else setActiveCollapKey("");
                }}
                // destroyInactivePanel={true}
              />
            </div>
          </div>
        </div>
        <div>
          {dateFrom == dateTo && !checkEmpty(dateFrom) && (
            <div style={{ paddingLeft: "17px" }}>
              <div>วันที่ : {dateFrom}</div>
              <div>เลขบนออก : {lotResualt?.lot_top}</div>
              <div>เลขล่างออก : {lotResualt?.lot_bottom}</div>
            </div>
          )}
          {loading ? (
            <LoadingCenterContent />
          ) : (
            <>
              <div
                style={{ fontWeight: "bold" }}
                className={styles.boxLotNumberResualt}
              >
                {/* <Table
                  className={styles.table}
                  columns={columns}
                  dataSource={datas}
                  pagination={false}
                /> */}
                <Row className={styles.rowHeader}>
                  <Col span={3} className={styles.columnHeaderTable}></Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    3 ตัวบน
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    3 ตัวล่าง
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    3 ตัวโต๊ด
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    2 ตัวบน
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    2 ตัวล่าง
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    วิ่งบน
                  </Col>
                  <Col span={3} className={styles.columnHeaderTable}>
                    วิ่งล่าง
                  </Col>
                </Row>

                <Row
                  className={styles.rowTableHeader1}
                  style={{ color: "green" }}
                >
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    ซื้อ {total_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_top_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_bottom_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_tot_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_2_top_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_2_bottom_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_run_top_buy}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_run_bottom_buy}
                  </Col>
                </Row>

                {/* <Row
                  className={styles.rowTableHeader1}
                  style={{ color: "green" }}
                >
                  <Col span={3} className={styles.columnTable}>
                    รับ {total_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_3_top_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_3_bottom_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_3_tot_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_2_top_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_2_bottom_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_run_top_recive}
                  </Col>
                  <Col span={3} className={styles.columnTable}>
                    {lot_run_bottom_recive}
                  </Col>
                </Row> */}
                <Row
                  className={styles.rowTableHeader1}
                  style={{ color: "red" }}
                >
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    จ่าย {total_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_top_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_bottom_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_3_tot_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_2_top_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_2_bottom_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_run_top_pay}
                  </Col>
                  <Col
                    span={3}
                    className={[
                      styles.columnTableHeader,
                      styles.columnTableFont,
                    ].join(" ")}
                  >
                    {lot_run_bottom_pay}
                  </Col>
                </Row>

                <Row
                  className={styles.rowTableHeader2}
                  style={{ color: "green" }}
                >
                  <Col span={3} className={[styles.columnTable2].join(" ")}>
                    <div>
                      {" "}
                      ตั้งรับ{" "}
                      <Button
                        disabled={!isAdmin()}
                        onClick={() => {
                          savePrevent();
                        }}
                      >
                        บันทึก
                      </Button>
                    </div>
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_3_top}
                      onChange={(e) => {
                        setprevent_3_top(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_3_top(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_3_bottom}
                      onChange={(e) => {
                        setprevent_3_bottom(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_3_bottom(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_3_tot}
                      onChange={(e) => {
                        setprevent_3_tot(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_3_tot(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_2_top}
                      onChange={(e) => {
                        setprevent_2_top(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_2_top(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_2_bottom}
                      onChange={(e) => {
                        setprevent_2_bottom(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_2_bottom(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_run_top}
                      onChange={(e) => {
                        setprevent_run_top(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_run_top(e.target.value.trim());
                      }}
                    />
                  </Col>
                  <Col span={3} className={styles.columnTable2}>
                    <Input
                      className={styles.columnTableInput}
                      placeholder={"ใส่เลข"}
                      value={prevent_run_bottom}
                      onChange={(e) => {
                        setprevent_run_bottom(e.target.value.trim());
                      }}
                      onKeyDown={(e) => {
                        setprevent_run_bottom(e.target.value.trim());
                      }}
                    />
                  </Col>
                </Row>

                <Row className={styles.rowTable}>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {Array.from(Array(numberTotalMain).keys()).map((v) => {
                      return <div className={styles.numberindex}>{v + 1}</div>;
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_3_tops.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        done = lotResualt.lot_top == object.lot_num;
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_3_bottoms.map((object) => {
                      return (
                        <div className={styles.itemNumber}>
                          <div className={styles.itemNumberIn}>
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_3_tots.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        let reverse3 = reverseString3(lotResualt.lot_top);
                        done = reverse3.includes(object.lot_num);
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_2_tops.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        done = lotResualt.lot_top.endsWith(object.lot_num);
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_2_bottoms.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        done = lotResualt.lot_bottom == object.lot_num;
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_run_tops.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        done = lotResualt.lot_top.indexOf(object.lot_num) != -1;
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                  <Col
                    span={3}
                    className={[styles.columnTable, styles.columnIn].join(" ")}
                  >
                    {lot_run_bottoms.map((object) => {
                      let done = false;
                      if (!checkEmpty(lotResualt)) {
                        done =
                          lotResualt.lot_bottom.indexOf(object.lot_num) != -1;
                      }
                      return (
                        <div className={styles.itemNumber}>
                          <div
                            className={
                              done
                                ? styles.itemNumberInDone
                                : styles.itemNumberIn
                            }
                          >
                            {object.lot_num}
                          </div>{" "}
                          <div
                            style={{ paddingLeft: "10px" }}
                            className={styles.priceItemIn}
                          >
                            {numberWithCommas(object.price)}
                          </div>
                        </div>
                      );
                    })}
                  </Col>
                </Row>
              </div>

              {orders.length == 0 && (
                <div className={styles.boxnodata}>
                  <div className={styles.nodata}>No data</div>
                </div>
              )}
            </>
          )}
        </div>
        <div
          style={{ paddingBottom: "50px", paddingTop: "50px" }}
          className={styles.backToTopDiv}
        >
          <Button
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            className={styles.backToTop}
          >
            Back To Top
          </Button>
        </div>
      </div>
      {contextHolderDone}
    </>
  );
}
export default LotSummaryNumber;
